import React, { useEffect, useState } from 'react';
import Seo from '../../../Components/SeoComponent/Seo';
import Header from '../../../Components/Header';
import { Button, InputWithLabel } from '../../../Components/Tags/Tags';
import Loader from '../../../Loader';
// import { companyCinService, fetchProfile } from '../../Services/ApiTestService/aadharTestService';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { cinData } from '../Data';
import { FaBuilding, FaUserTie, FaMoneyBill, FaEnvelope, FaMapMarkerAlt, FaCalendarAlt, FaCopy } from 'react-icons/fa';
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { useService } from '../../../context/ServiceContext';
import { companyCinService } from '../../../Services/ApiTestService/apiTestService';
import { fetchProfile } from '../../../Services/profile/profileservice';


const BasicCompanyCin = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [cin, setCin] = useState('');
    const [message, setMessage] = useState({ message: "", type: "error" });
    const [profileData, setProfileData] = useState({});
    const [companyData, setCompanyData] = useState(null);
    const { serviceName } = useService();

    async function handleSubmit() {
        if (cin === "") {
            setMessage({ message: "Company CIN required.", type: "error" });
            return;
        }

        setIsLoading(true);
        try {
            setMessage({ message: "Verifying CIN...", type: "success" });
            const payload = {
                api_id: profileData?.user_id,
                api_key: profileData?.api_key,
                token_id: profileData?.token_id,
                cin: cin
            };
            let response = await companyCinService({ payload });
            if (response.status.code === 200) {
                setIsLoading(false);
                showSuccessToast(response.message);
                setMessage({ message: response?.message, type: "success" });
                setCompanyData(response.data);
                setCin('');
            } else {
                setIsLoading(false);
                showErrorToast(response.message || response.data.message || response.error.message || "Something went wrong.");
                setMessage({ message: "Something went wrong. Please try again.", type: "error" });
            }
        } catch (error) {
            setIsLoading(false);
            setMessage({ message: "Something went wrong. Please try again.", type: "error" });

        }
    }

    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                setIsLoading(true);
                const response = await fetchProfile();
                setProfileData(response.data);
            } catch (error) {
                console.error("Error fetching profile data:", error);
                showErrorToast("Failed to fetch profile data.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchProfileData();
    }, []);



    const renderCompanyCard = () => {
    if (!companyData?.details?.company_info) {
        return (
            <div className="text-center p-4 bg-red-100 border border-red-300 text-red-700 rounded">
                No company data available.
            </div>
        );
    }

    const company_info = companyData.details.company_info;

    return (
        <div className="relative bg-white/70 backdrop-blur-lg border border-blue-100 p-6 rounded-2xl shadow-xl max-w-2xl mx-auto">

            <div className="absolute top-4 right-4 w-10 h-6 bg-yellow-400 rounded-sm shadow-inner" />

            <div className="mb-4 flex items-center gap-2">
                <FaBuilding className="text-blue-600 text-xl" />
                <h2 className="text-2xl font-bold text-blue-900">
                    {companyData?.company_name || "Company Name Not Available"}
                </h2>
            </div>

            <div className="text-gray-700 text-sm space-y-2">
                <p className="flex items-center gap-2">
                    
                    <FaCalendarAlt className="text-gray-500" />
                    <strong>Incorporated:</strong> {company_info?.date_of_incorporation || "N/A"}
                </p>

                <p className="flex items-center gap-2">
                    <FaMoneyBill className="text-gray-500" />
                    <strong>Company Type:</strong> {companyData?.company_type || "N/A"}
                </p>

                <p className="flex items-center gap-2">
                    <FaEnvelope className="text-gray-500" />
                    <strong>Email:</strong> {company_info?.email_id || "Not Provided"}
                </p>

                <p className="flex items-center gap-2">
                    <FaMapMarkerAlt className="text-gray-500" />
                    <strong>Address:</strong> {company_info?.registered_address || "Not Available"}
                </p>

                <p className="text-xs italic text-blue-500">
                    CIN: {company_info?.cin || "Unavailable"}
                </p>

                <p className="text-xs text-gray-500">
                    ROC: {company_info?.roc_code || "N/A"}
                </p>
            </div>

            {/* Directors removed because API not sending */}
            {/* Charges removed because API not sending */}

        </div>
    );
};



    function handleCopyText(data) {
        window.navigator.clipboard.writeText(JSON.stringify(data));
        showSuccessToast('Copied successfully')
    }

    return (
        <div className="p-4">
            <Seo title={serviceName} />
            <Header heading={serviceName} />
            {isLoading && <Loader />}

                  
                  <div className="col-span-2 md:col-span-6 flex justify-end">
              <Link
                to="/TestMaster"
                className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
              >
                <span>Go Back</span>
                <IoArrowBackCircleOutline size={24} />
              </Link>
            </div>

            <div className='flex items-end gap-2'>

                <div>
                    <InputWithLabel
                        label={"CIN"}
                        placeholder={"Enter CIN number."}
                        required={true}
                        value={cin}
                        onChange={(e) => setCin(e.target.value)}
                    />
                    <span className={`${message.type === "error" ? 'text-red-800' : 'text-green-500'}`}>{message.message}</span>
                </div>
                <Button text={'Verify'} type={'button'} onClick={handleSubmit} />
            </div>

            {companyData && (
                <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>{renderCompanyCard()}</div>
                    <pre className="bg-black relative text-green-500 p-4 rounded text-sm overflow-auto max-h-[600px]">
                    <FaCopy className="absolute top-2 cursor-pointer right-2  bg-white p-1 rounded-md font-bold text-2xl" onClick={()=>handleCopyText(companyData)} />
                        {JSON.stringify(companyData, null, 2)}
                    </pre>
                </div>
            )}
        </div>
    );
};

export default BasicCompanyCin;
